import { LazyLoadingSectionLogger, LoggingSection } from "@multiweb/logging";
import { EMPTY_ITEM_RIGHTS_COLLECTION } from "../../../../Global/Base/Rights/RightTypes";
import { createElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { IFRMParams } from "../Controls/FormParameters";
import { FormManager } from "../FormManager/IFormManager";
import { IWindowable } from "../UIManagerInterfaces";
import { ChartFrame } from "../XGControls/Frames/ChartFrame";
import { IMasterableFrameWithDataGrid } from "../XGControls/Frames/FrameInterfaces";
import { IForm } from "../XGControls/IForm";
import { IChartFrameFormBuilder } from "./IFormBuilder";
import { ProgrammableForm } from "./ProgrammableForm";

const logger = LazyLoadingSectionLogger.create(LoggingSection.chartFrame);

/**
 * Sestaví modální formulář pro graf
 */
export class ChartFrameFormBuilder implements IChartFrameFormBuilder {
    /**
     * Sestaví modální formulář pro ChartFrame
     * @param parametricData Volitelné parametry formuláře
     */
    public async build(parametricData?: IFRMParams): Promise<IWindowable> {
        const formCode = "dynamicFrm.chartFrame";
        const formInstanceId = FormManager.instance.createFormInstanceId(formCode, parametricData);
        const form = new ProgrammableForm(formCode, formInstanceId, parametricData);
        form.isModal = true;
        form.titleLocKey = "GUI-1500"; //Graf

        await FormManager.instance.openCustomModalForm(form);
        const chartFrame = await this._createChartFrame(form, parametricData);
        form.addControl(chartFrame.element);

        await form.init();

        await chartFrame.initialize();
        chartFrame.showSettingPanel();
        chartFrame.loadAndSelectRecord(parametricData.selectedID);

        return form;
    }

    private async _createChartFrame(ownerForm: IForm, parametricData: IFRMParams): Promise<ChartFrame> {
        const chartElement = createElement();
        chartElement.setAttribute("data-behaviour", "frame");
        if (parametricData.executerFrame) {
            chartElement.setAttribute("data-objectname", parametricData.executerFrame.objectName);
            chartElement.setAttribute("data-masterframe", parametricData.executerFrame.frameName);
        }
        const chartFrame = new ChartFrame({
            ownerForm,
            element: chartElement,
            originalRightsDefinition: EMPTY_ITEM_RIGHTS_COLLECTION,
            isInModalWindow: true,
        });
        chartFrame.frameName = "ChartFrame";
        if (parametricData.executerFrame instanceof IMasterableFrameWithDataGrid) chartFrame.masterFrame = parametricData.executerFrame;
        else logger.error("Cannot open chart frame. Master frame is not instance of IMasterableFrameWithDataGrid");
        return chartFrame;
    }
}
